import {get, post} from './api';

/*
获取Guide请求参数示例：
{
    id: 1
}
*/
const getGuide = get('guide/get');

//获取自己创建的guide列表，无需传入参数
const getMyGuides = get('guide/list');

//预留，暂时用不到，后端还没有实现
const getRecommendedGuides = get('guide/recommended');

/*
保存Guide示例：
{
    "id": 1,
    "project_id": 1,
    "title": "test",
    "steps": "[{\"action\":\"restart\"}]"
}
 */
const saveGuide = post('guide/save');

export {
    getGuide,
    getMyGuides,
    saveGuide
}
